import React, { createContext, useContext, useRef, useEffect } from 'react';

const DataCacheContext = createContext(null);

export const DataCacheProvider = ({ children }) => {
  const store = useRef({});
  const get = (key) => store.current[key];
  const set = (key, data) => { store.current[key] = data; };
  const invalidate = (key) => { delete store.current[key]; };
  const clearAll = () => { store.current = {}; };

  useEffect(() => {
    const handler = () => clearAll();
    window.addEventListener('user-session-cleared', handler);
    return () => window.removeEventListener('user-session-cleared', handler);
  }, []);

  return (
    <DataCacheContext.Provider value={{ get, set, invalidate, clearAll }}>
      {children}
    </DataCacheContext.Provider>
  );
};

export const useDataCache = () => useContext(DataCacheContext);
